import { style } from 'typestyle';
import { ButtonStateTypes, stateStylesSet, stylesSet } from '../../../styles/button';
import Loader from '../../atoms/loader/Loader';
import { DoneIcon } from '../../atoms/icons/Icons';
import { Gold } from '../../../styles/colors';
import * as React from 'react';
const resultStyleSet = Object.assign(Object.assign({}, stylesSet), stateStylesSet);
export const getButtonStyles = () => {
    const styles = {};
    Object.keys(resultStyleSet).forEach(type => {
        styles[type] = style({
            $nest: {
                [`&.ta-btn-style-${type}`]: resultStyleSet[type],
                [`&.ta-btn-style-${type} > span`]: {
                    color: resultStyleSet[type].color,
                },
                '& svg': {
                    display: 'flex',
                },
            },
        });
    });
    return styles;
};
const defaultPendingIcon = React.createElement(Loader, { color: Gold });
const defaultDoneIcon = React.createElement(DoneIcon, null);
export function getStateDependentValues({ done, doneIcon = defaultDoneIcon, doneTitle, pending, pendingIcon = defaultPendingIcon, pendingTitle, disabled, styleType, disabledIcon, icon, title, }) {
    let resultStyleType = styleType;
    let resultIcon = icon;
    let resultTitle = title;
    if (done) {
        resultTitle = doneTitle;
        resultIcon = doneIcon;
        resultStyleType = ButtonStateTypes.Done;
    }
    if (pending) {
        resultTitle = pendingTitle;
        resultIcon = pendingIcon;
        resultStyleType = ButtonStateTypes.Pending;
    }
    if (disabled) {
        resultIcon = disabledIcon ? disabledIcon : resultIcon;
        resultStyleType = ButtonStateTypes.Disabled;
    }
    return { styleType: resultStyleType, icon: resultIcon, title: resultTitle };
}
export function getButtonSizeStyle({ icon, title, small, naked, }) {
    // Naked
    if (naked) {
        return iconNakedStyle;
    }
    // Label, Icon+Label
    if (title && !small) {
        return labelLargeStyle;
    }
    // Label Small, Icon+Label Small
    if (title && small) {
        return labelSmallStyle;
    }
    // Icon
    if (icon && !small) {
        return iconLargeStyle;
    }
    // Icon Small
    if (icon && small) {
        return iconSmallStyle;
    }
    return '';
}
const iconNakedStyle = style({
    height: 24,
    padding: 0,
    borderRadius: 8,
});
const labelLargeStyle = style({
    height: 40,
    padding: '0 12px',
});
const labelSmallStyle = style({
    height: 36,
    padding: '0 12px',
});
const iconLargeStyle = style({
    height: 40,
    padding: '0 8px',
});
const iconSmallStyle = style({
    height: 36,
    padding: '0 6px',
});
//# sourceMappingURL=helpers.js.map